<template>
  <v-app>
    <v-progress-linear v-if="$store.state.globalLoading" indeterminate></v-progress-linear>
    <v-main>
      <v-fade-transition mode="out-in">
        <router-view/>
      </v-fade-transition>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  })
}
</script>

<style>
html,
body {
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  background: #c23d69;
  border-radius: 0px;
}
::-webkit-scrollbar-thumb:hover {
  background: #ce2960;
}
::-webkit-scrollbar-track {
  background: #e8e8e8;
  border-radius: 0px;
}
</style>
